module.exports = __webpack_public_path__ + "static/media/Human_ZG5850-Edit_1440.60db8435.jpeg";